import React, { useState } from "react";
import Progressbar from "../loading";

import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import { useDispatch } from "react-redux";
import { updateSession } from "@/src/lib/util/updateSession";
import { useRouter } from "next/router";

import { usePatientAddressList } from "@/src/lib/module-helper/my-account/hook/useAddressQuery";
import CustomButton from "@/src/lib/ui/Button";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import { CustomRadioGroup } from "@/src/lib/ui/customRadioGroup";

const AddressListPopup = ({
    open,
    onClose,
    selectedAddress,
    handleAddressChange,
}) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const isMobile = useBreakpoint("sm");

    const { patientAddressList, isLoadingPatientAddressList } =
        usePatientAddressList(open);
    const handleRadioChange = async (_, val) => {
        const selectedAddress = patientAddressList.find(
            (item) => item.AddressID === val
        );

        const sessionUpdateType = "ADDRESS"; // or 'CENTRE', 'CART', 'HOOKCITY'
        const address = {
            pincode: selectedAddress?.Pincode,
            addressGuid: val,
            address: selectedAddress?.Address,
        };

        handleAddressChange(address);
        await updateSession(sessionUpdateType, { address }, dispatch);

        onClose();
    };

    const handleManageAddresses = () => {
        // Handle manage patientAddressList logic here
        // console.log("Manage Addresses clicked");
        router.push("/my-account/address");
    };

    const editAddressHandler = (addressGuid) => {
        router.push(`/my-account/address/edit/${addressGuid}`);
    };

    return (
        <ConfirmDialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            maxWidth="md"
            title={
                <div className="flex items-center justify-between border-b border-solid border-gray-200 -mx-4 px-4 pb-4">
                    <p className="text-black font-bold text-xl">
                        Select Address
                    </p>
                    <Iconify
                        icon={IconCode.close}
                        width="24"
                        onClick={onClose}
                        className="cursor-pointer"
                    />
                </div>
            }
            content={
                <>
                    <div className="p-0">
                        {isLoadingPatientAddressList ? (
                            <div className="flex items-center justify-center mb-5">
                                <Progressbar />
                            </div>
                        ) : (
                            <CustomRadioGroup
                                value={selectedAddress}
                                onChange={handleRadioChange}
                                name="address"
                            >
                                {patientAddressList?.length === 0 ? (
                                    <div className="text-center py-4 ">
                                        <p className="font-medium text-black">
                                            No addresses added.
                                        </p>
                                        <p className="text-gray-600">
                                            Please go to "Manage Addresses" to
                                            add a new address.
                                        </p>
                                    </div>
                                ) : (
                                    patientAddressList.map((address, index) => (
                                        <div
                                            className={`py-3 border-b border-solid border-gray-200 last:border-b-0 flex items-center gap-4 -mx-4 px-6`}
                                            key={address.AddressID}
                                        >
                                            <input
                                                type="radio"
                                                value={address.AddressID}
                                                className="w-3 h-3 bg-primary"
                                                style={{
                                                    transform: "scale(1.5)",
                                                }}
                                            />

                                            <div className="font-medium text-black leading-6 flex items-center gap-2 justify-between w-full">
                                                <div>
                                                    <p>{address.Address}</p>
                                                    <p className="text-gray-600 text-sm">
                                                        {address.Pincode}
                                                    </p>
                                                </div>

                                                <div className="cursor-pointer w-8 h-8">
                                                    <Iconify
                                                        icon={IconCode.edit}
                                                        className="text-black "
                                                        width={24}
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // Prevent radio selection when clicking edit
                                                            editAddressHandler(
                                                                address?.AddressID
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </CustomRadioGroup>
                        )}
                    </div>
                    <div className="sticky bottom-0 bg-white p-4">
                        <CustomButton
                            variant="outlined"
                            className="text-redPrimary border-redPrimary w-full p-3 rounded-md"
                            onClick={handleManageAddresses}
                        >
                            Manage Addresses
                        </CustomButton>
                    </div>
                </>
            }
        ></ConfirmDialog>
    );
};

export default AddressListPopup;
